// Card Quick Add - Add variant to cart without page refresh
class CardQuickAdd {
  constructor() {
    this.init();
  }

  init() {
    // Attach click event to all quick add buttons
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.card-quick-add-btn');
      if (!button || button.classList.contains('disabled')) return;

      event.preventDefault();
      event.stopPropagation();
      
      // Check screen size
      if (window.innerWidth <= 768) {
        // Mobile: Select variant instead of adding to cart
        this.selectVariant(button);
      } else {
        // Desktop: Add to cart directly
        this.addToCart(button);
      }
    });

    // Add event listener for mobile add to cart button
    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('.mobile_quick_add_add_to_cart');
      if (!addButton) return;

      event.preventDefault();
      event.stopPropagation();
      
      this.addSelectedVariantToCart();
    });
  }

  selectVariant(button) {
    // Remove selected class from all variant buttons in the mobile quick add
    const mobileQuickAdd = document.querySelector('.mobile_quick_add');
    if (mobileQuickAdd) {
      const allButtons = mobileQuickAdd.querySelectorAll('.card-quick-add-btn');
      allButtons.forEach(btn => btn.classList.remove('selected'));
    }
    
    // Add selected class to clicked button
    button.classList.add('selected');
    
    // Get delivery date from button and render it inside variant-info
    const deliveryDate = button.dataset.deliveryDate ? button.dataset.deliveryDate.trim() : '';
    const variantInfo = document.querySelector('.variant-info');
    
    if (variantInfo && deliveryDate) {
      variantInfo.textContent = deliveryDate;
      variantInfo.style.display = 'block';
    } else if (variantInfo) {
      variantInfo.textContent = '';
      variantInfo.style.display = 'none';
    }
  }

  addSelectedVariantToCart() {
    const mobileQuickAdd = document.querySelector('.mobile_quick_add');
    if (!mobileQuickAdd) return;

    const selectedButton = mobileQuickAdd.querySelector('.card-quick-add-btn.selected');
    if (!selectedButton) {
      alert('Please select a variant first');
      return;
    }

    this.addToCart(selectedButton);
  }

  addToCart(button) {
    const variantId = button.dataset.id;
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    button.classList.add('loading');
    button.disabled = true;

    const cartDrawer = document.querySelector('cart-drawer');
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    if (cartDrawer) {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('Error adding to cart:', response.description);
          if (response.description) {
            alert(response.description);
          }
          return;
        }

        // Close mobile quick add
        const mqa = document.querySelector('.mobile_quick_add');
        const mqaLayer = document.querySelector('.mobile-quick-add-layer');
        if (mqa) {
          mqa.classList.remove('active');
          const sizesContainer = mqa.querySelector('.mobile_quick_add_sizes');
          if (sizesContainer) sizesContainer.innerHTML = '';
        }
        if (mqaLayer) mqaLayer.classList.remove('active');
        document.querySelectorAll('.quick-add-open').forEach(btn => btn.classList.remove('active'));

        // Prysm intercepts the fetch above via its installNetworkHooks and opens
        // the drawer automatically — no manual renderContents or redirect needed.
        // We only call renderContents if a native Dawn cart-drawer element exists
        // (i.e. the store is NOT using Prysm).
        const prysmCart = document.querySelector('[id^="prysm-cart-drawer-"]');
        if (cartDrawer && !prysmCart) {
          cartDrawer.classList.remove('is-empty');
          const cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-quick-add',
            productVariantId: variantId,
            cartData: response
          });

          cartDrawer.renderContents(response);

          setTimeout(() => {
            const productRecs = document.querySelector('cart-drawer product-recommendations');
            if (productRecs) {
              const cartDrawerItems = document.querySelector('cart-drawer-items');
              if (cartDrawerItems) cartDrawerItems.scrollTop = cartDrawerItems.scrollTop;

              const slideshowComponent = productRecs.querySelector('slideshow-component');
              if (slideshowComponent) {
                window.dispatchEvent(new Event('resize'));
                const slider = slideshowComponent.querySelector('.complementary-slider');
                if (slider) slider.scrollLeft = 0;
              }
            }
          }, 150);
        }
        // If prysmCart is present, Prysm has already handled the drawer open+refresh.
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        alert('There was an error adding the item to your cart. Please try again.');
      })
      .finally(() => {
        button.classList.remove('loading');
        button.disabled = false;
        
        const prysmCartFinal = document.querySelector('[id^="prysm-cart-drawer-"]');
        if (cartDrawer && !prysmCartFinal && cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }
      });
  }
}

// Initialize when DOM is ready — limpiar cualquier clase active residual del HTML
function initCardQuickAdd() {
  document.querySelectorAll('.quick-add-open').forEach(btn => btn.classList.remove('active'));
  document.querySelectorAll('.card-quick-add-container').forEach(el => el.classList.remove('active'));
  new CardQuickAdd();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCardQuickAdd);
} else {
  initCardQuickAdd();
}

// Abrir quick add (desktop: panel de tallas, mobile: bottom sheet)
document.addEventListener('click', (event) => {
  const button = event.target.closest('.quick-add-open');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();
  
  // Producto con una sola variante: añadir directo al carrito
  if (button.classList.contains('directly-add-to-cart')) {
    const variantId = button.dataset.id;
    if (!variantId) { console.error('No variant ID found'); return; }
    const cardQuickAdd = new CardQuickAdd();
    cardQuickAdd.addToCart(button);
    return;
  }

  const mobileQuickAdd = document.querySelector('.mobile_quick_add');
  const mobileQuickAddLayer = document.querySelector('.mobile-quick-add-layer');
  if (!mobileQuickAdd || !mobileQuickAddLayer) return;

  if (window.innerWidth > 768) {
    // Desktop: toggle panel de tallas
    const cardQuickAddContainer = button.closest('.product-card-wrapper').querySelector('.card-quick-add-container');
    if (cardQuickAddContainer) {
      cardQuickAddContainer.classList.toggle('active');
      button.classList.toggle('active');
    }
  } else {
    // Mobile: abrir bottom sheet
    const variantInfoEl = document.querySelector('.mobile-quick-add-header .variant-info');
    if (variantInfoEl) variantInfoEl.textContent = '';

    const cardQuickAddInner = button.closest('.product-card-wrapper').querySelector('.card-quick-add-inner');
    if (cardQuickAddInner) {
      const clonedContainer = cardQuickAddInner.cloneNode(true);
      mobileQuickAdd.querySelector('.mobile_quick_add_sizes').innerHTML = clonedContainer.innerHTML;
      mobileQuickAdd.classList.add('active');
      mobileQuickAddLayer.classList.add('active');
      button.classList.add('active');
    }
  }
});

// Cerrar al tocar el overlay
document.addEventListener('click', (event) => {
  if (!event.target.closest('.mobile-quick-add-layer')) return;
  const mobileQuickAdd = document.querySelector('.mobile_quick_add');
  const mobileQuickAddLayer = document.querySelector('.mobile-quick-add-layer');
  if (mobileQuickAdd) {
    mobileQuickAdd.classList.remove('active');
    const sizesContainer = mobileQuickAdd.querySelector('.mobile_quick_add_sizes');
    if (sizesContainer) sizesContainer.innerHTML = '';
  }
  if (mobileQuickAddLayer) mobileQuickAddLayer.classList.remove('active');
  document.querySelectorAll('.quick-add-open').forEach(btn => btn.classList.remove('active'));
});

// Cerrar al tocar la barra superior del sheet
document.addEventListener('click', (event) => {
  if (!event.target.closest('.mobile_quick_add_close-part')) return;
  const mobileQuickAdd = document.querySelector('.mobile_quick_add');
  const mobileQuickAddLayer = document.querySelector('.mobile-quick-add-layer');
  if (mobileQuickAdd) {
    mobileQuickAdd.classList.remove('active');
    const sizesContainer = mobileQuickAdd.querySelector('.mobile_quick_add_sizes');
    if (sizesContainer) sizesContainer.innerHTML = '';
  }
  if (mobileQuickAddLayer) mobileQuickAddLayer.classList.remove('active');
  document.querySelectorAll('.quick-add-open').forEach(btn => btn.classList.remove('active'));
});